import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Badge from '@mui/material/Badge';
export const IconWithUpdates = ({ numUpdates, children }) => {
    return (_jsx(Badge, { color: 'secondary', badgeContent: numUpdates < 10 ? numUpdates : '+', overlap: 'circular', children: children }));
};
